"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoAnalyticsManager = void 0;
var tslib_1 = require("tslib");
var VideoAnalyticsManager = /** @class */ (function () {
    function VideoAnalyticsManager(analyticsConfig) {
        this.analyticsInstances = [];
        this.analyticsConfig = analyticsConfig;
    }
    VideoAnalyticsManager.prototype.setup = function (videoAnalyticsConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _i, _a, analytics, videoAnalytics, analyticsInstance, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.analyticsConfig;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        analytics = _a[_i];
                        if (!analytics.enable)
                            return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, Promise.resolve().then(function () { return tslib_1.__importStar(require("./analytics/".concat(analytics.vendor_name, "/videoAnalytics"))); })];
                    case 3:
                        videoAnalytics = (_b.sent()).videoAnalytics;
                        analyticsInstance = new videoAnalytics(analytics);
                        analyticsInstance.setup(videoAnalyticsConfig);
                        this.analyticsInstances.push(analyticsInstance);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        console.error("Error setting up analytics for vendor ".concat(analytics.vendor_name, ":"), error_1);
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    VideoAnalyticsManager.prototype.destroy = function () {
        this.analyticsInstances.forEach(function (analyticsInstance) {
            if (analyticsInstance.destroy) {
                analyticsInstance.destroy();
            }
        });
        this.analyticsInstances = [];
    };
    return VideoAnalyticsManager;
}());
exports.VideoAnalyticsManager = VideoAnalyticsManager;
